import CaptureButton from './CaptureButton';
const screenShot = {
    key: 'screenShot',
    Content: CaptureButton,
    group: 10
};
/**
 * A hook that returns the capture button.
 *
 *  @returns {Object}
 */
export function useCaptureButton() {
    return screenShot;
}
